import React from 'react';
import { Link } from 'react-router-dom';
import './noAuth.css';

const UnauthorizedPage = () => {
  return (
    <div className="unauthorized-container">
      <div className="unauthorized-content">
        {/* Logo de 99 Envíos */}
        <div className="logo-container">
          <h2 className="brand-logo">
            <span className="part1">99</span>
            <span className="part2">ENV</span><span className="part3">ÍOS</span>
          </h2>
        </div>

        {/* Icono personalizado de 99 Envíos */}
        <div className="lock-icon">
          <img src="/Images/download.png" alt="99 Envíos Icon" />
        </div>

        {/* Código de error y mensaje */}
        <h1 className="error-code">403</h1>
        <h2 className="error-title">Acceso Denegado</h2>
        <p className="error-message">
          Lo sentimos, no tienes los permisos necesarios para acceder a esta página.
          Si crees que esto es un error, contacta a tu administrador.
        </p>

        {/* Información adicional */}
        <div className="info-box">
          <div className="info-item">
            <span className="info-icon">🔒</span>
            <span>Área protegida</span>
          </div>
          <div className="info-item">
            <span className="info-icon">🚚</span>
            <span>99 Envíos</span>
          </div>
        </div>

        {/* Botones de acción */}
        <div className="action-buttons">
          <Link to="/" className="btn btn-primary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 12L21 12M3 12L7 8M3 12L7 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Volver al inicio
          </Link>
          <button 
            onClick={() => window.history.back()} 
            className="btn btn-secondary"
          >
            Página anterior
          </button>
        </div>

        {/* Footer */}
        <div className="unauthorized-footer">
          <p>¿Necesitas ayuda? Contacta al soporte técnico</p>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
